import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Shown in the desktop app when the license has expired (login-time or mid-session).
 * User stays logged in in restricted mode — only /profile and /sync are accessible.
 */
export default function LicenseBanner() {
  const { isAuthenticated, licenseExpired } = useAuth();
  const navigate = useNavigate();

  if (!window.electronAPI || !isAuthenticated || !licenseExpired) return null;

  return (
    <div style={{
      background: '#fef2f2', borderBottom: '2px solid #fca5a5',
      padding: '8px 1.25rem', fontSize: '0.82rem', color: '#991b1b',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.75rem',
    }}>
      <span>⚠️</span>
      <span>
        Your desktop license has expired. Access is restricted to Profile and Sync pages.
      </span>
      <button
        onClick={() => navigate('/profile')}
        style={{
          padding: '3px 12px', fontSize: '0.78rem', fontWeight: 600,
          background: '#dc2626', color: 'white', border: 'none',
          borderRadius: 6, cursor: 'pointer', whiteSpace: 'nowrap',
        }}
      >
        View License →
      </button>
    </div>
  );
}
